"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _attachmentInterfaces = require("./attachmentInterfaces");

Object.keys(_attachmentInterfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _attachmentInterfaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _attachmentInterfaces[key];
    }
  });
});

var _productAreasInterface = require("./productAreasInterface");

Object.keys(_productAreasInterface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productAreasInterface[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _productAreasInterface[key];
    }
  });
});

var _userInterfaces = require("./userInterfaces");

Object.keys(_userInterfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userInterfaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _userInterfaces[key];
    }
  });
});

var _translation = require("./translation");

Object.keys(_translation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _translation[key];
    }
  });
});